module.exports = __webpack_public_path__ + "media/warranty-claim/house-success-99bcf3f8.svg";